import { useLoginStore } from '../login.store';
import { useServicesStore } from '../services.store';
import { useTranslationsStore } from '../translations.store';

export const useResetSessionStore = () => {
	const loginResetState = useLoginStore((state) => state.resetState);
	const servicesResetState = useServicesStore((state) => state.resetState);
	const translationsResetState = useTranslationsStore((state) => state.resetState);

	return () => {
		loginResetState({});
		servicesResetState({});
		translationsResetState({});
	};
};
